var _path, _g, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect2, _rect3, _path10, _path11, _rect4, _rect5, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _rect6, _path19, _rect7, _rect8, _path20, _path21, _path22, _g2, _path23, _path24, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartMeetingIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363.1 353.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M189.8,245.7c1,12.4-12.1,22.2-16.1,22.2-3.8,0-16.3-8.8-16.3-20a18,18,0,0,1,.2-2.2c-21.6,3.9-30.9,23-28,47,12.4,10.5,27,15.6,44.2,15.6s29.1-5.1,41.4-15.6C215.2,258.1,201.4,246.7,189.8,245.7Z",
    fill: "#d1e545"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pulse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.93,49.83l-17-14.25,20.88-6.38ZM175.07,36.62l10.2,8.55,2.32-12.37Z",
    fill: "#d1e545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pulse-2",
    "data-name": "Pulse",
    d: "M234.8,164.8l-.7-19.6-15,14.9-5.7-11.7-8.8,3.7-1.2-2.8,11.4-4.8L220,155l16.9-16.8,1,26.5Z",
    fill: "#d1e545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pulse-3",
    "data-name": "Pulse",
    d: "M112.2,224.7a8.5,8.5,0,1,1,8.5-8.5h0A8.43,8.43,0,0,1,112.2,224.7Zm0-14a5.48,5.48,0,0,0-5.5,5.5,5.55,5.55,0,0,0,5.5,5.5,5.48,5.48,0,0,0,5.5-5.5h0a5.42,5.42,0,0,0-5.5-5.5Z",
    fill: "#d1e545"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_1",
    "data-name": "Rechteck 1",
    x: 11.5,
    y: 334.6,
    width: 312.7,
    height: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_4",
    "data-name": "Pfad 4",
    d: "M22.7,336.3a200.77,200.77,0,0,1,.4-50.2c2.7-20,8.5-42.7,14.4-56.5l.7-1.6,1.5.9a65.07,65.07,0,0,0,31.6,9.4h.9l.4.8c5,9.8,10.1,25.9,14.5,40.5,3,9.8,5,22.6,6.3,31l-3,.5c-1.3-8.4-3.3-21-6.2-30.6-4.2-14-9.1-29.6-13.9-39.2a67,67,0,0,1-30.6-8.9C34.8,244,29,264.6,26.1,286.5a195.23,195.23,0,0,0-.4,49.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_5",
    "data-name": "Pfad 5",
    d: "M108,320h-3v-4.5H81c-8.8,0-14-10.1-14-19.9V268.5h3v27.1c0,6.8,3.5,16.9,11,16.9h27ZM73.6,337.6a33.29,33.29,0,0,1-33.3-33.3V275h3v29.4a30.34,30.34,0,0,0,30.3,30.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_6",
    "data-name": "Pfad 6",
    d: "M119.4,337.6H105V318.3h14.4Zm-11.4-3h8.4V321.3H108Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_7",
    "data-name": "Pfad 7",
    d: "M150.9,337.6l-.2-3a3.46,3.46,0,0,0,3.4-3.5,3.54,3.54,0,0,0-2.9-3.5l-13.5-.2a4,4,0,0,1-2.9-2.3,3.63,3.63,0,0,1,.2-3.5l.1-.2,3.2-4.2.1-.2c.6-.8.6-1.1.5-1.2a1.89,1.89,0,0,0-.6-.4c-.4-.2-1.5,0-5.2,2a40.21,40.21,0,0,1-15.6,3.8l-.1-3a37.1,37.1,0,0,0,14.2-3.5c3.4-1.8,6-2.8,7.8-2.1a3.91,3.91,0,0,1,2.4,2.3,4.76,4.76,0,0,1-.9,3.8l-.2.2-3.2,4.1a1.1,1.1,0,0,0,0,.8.74.74,0,0,0,.6.5l13.5.2A6.64,6.64,0,0,1,157,331a6.3,6.3,0,0,1-6.1,6.6Zm161.2-1.3-3-.4a200,200,0,0,0-.4-49.5c-3-22.1-9-42-13.5-53a67.38,67.38,0,0,1-30.6,8.9c-4.1,8.3-8.8,21.1-13.9,38.1a197.43,197.43,0,0,0-6.2,27.4l-3-.5a217.75,217.75,0,0,1,6.3-27.7c5.3-17.7,10.2-31,14.5-39.4l.4-.8h.9a65.07,65.07,0,0,0,31.6-9.4l1.5-.9.7,1.6c6.1,14.3,11.8,36,14.4,55.4a200.77,200.77,0,0,1,.3,50.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_8",
    "data-name": "Pfad 8",
    d: "M229.8,319.9h-3v-8.6h24.6c7.6,0,13.4-8.5,13.4-15.8V268.4h3v27.1c0,8.9-7,18.8-16.4,18.8H229.8v5.6Zm31.4,17.7v-3a30.34,30.34,0,0,0,30.3-30.3V275h3v29.4a33.14,33.14,0,0,1-33.3,33.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_9",
    "data-name": "Pfad 9",
    d: "M229.8,337.6H215.4V318h14.4Zm-11.4-3h8.4V321h-8.4Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_10",
    "data-name": "Pfad 10",
    d: "M216.5,320.9a15,15,0,0,1-8.3-1.9,26.89,26.89,0,0,0-5.6-2.1l.8-2.9a34.67,34.67,0,0,1,6.1,2.3,13.13,13.13,0,0,0,7,1.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_11",
    "data-name": "Pfad 11",
    d: "M208.8,337.6c-5.2,0-13.7-3.5-16.9-5.2-4.8-2.5-6.8-6.8-5.1-10.9a24.21,24.21,0,0,1,4.9-8.5,8.65,8.65,0,0,1,9.2-1.6l-1.2,2.7a5.59,5.59,0,0,0-5.8.9,21.35,21.35,0,0,0-4.2,7.5l-.1.2c-1.4,3.1,1,5.7,3.7,7.1,3.8,2,11.3,4.8,15.6,4.8v3Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_2",
    "data-name": "Rechteck 2",
    x: 182.23,
    y: 331.3,
    width: 8.3,
    height: 3,
    transform: "translate(-192.28 286.85) rotate(-53.83)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_3",
    "data-name": "Rechteck 3",
    x: 191.21,
    y: 305.62,
    width: 25.9,
    height: 3,
    transform: "translate(-164.62 309.54) rotate(-56.76)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_12",
    "data-name": "Pfad 12",
    d: "M187.6,166.8h-3a15.6,15.6,0,1,0-31.2,0h-3a18.6,18.6,0,1,1,37.2,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    d: "M196.8,208.6l-2.7-1.3c5.1-10.7,4.4-21.5-2.1-31.2a29.32,29.32,0,0,0-22.8-12.9h-.4a29.14,29.14,0,0,0-27.7,29.5h-3a31.85,31.85,0,0,1,5.4-18.2,32.67,32.67,0,0,1,25.3-14.3h.5a32.39,32.39,0,0,1,25.3,14.3C201.5,184.9,202.3,197,196.8,208.6Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_4",
    "data-name": "Rechteck 4",
    x: 139.2,
    y: 275.7,
    width: 3,
    height: 21.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_5",
    "data-name": "Rechteck 5",
    x: 195.7,
    y: 275.7,
    width: 3,
    height: 17.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    "data-name": "Pfad 14",
    d: "M72.4,225.5a7.57,7.57,0,0,1-1.5-.1,21.63,21.63,0,0,1-14.4-7.8l2.3-1.9a17.6,17.6,0,0,0,12.3,6.6,15,15,0,0,0,6.3-.8,4.54,4.54,0,0,0,3-3.3c.2-.7.3-1.4.5-2a48.49,48.49,0,0,0,1.6-10,81,81,0,0,0-1.8-23l2.9-.6a86.38,86.38,0,0,1,1.8,23.8,52.3,52.3,0,0,1-1.7,10.5c-.2.6-.3,1.3-.5,2a7.53,7.53,0,0,1-5,5.5,14.26,14.26,0,0,1-5.8,1.1Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    d: "M50.2,205.5a12.83,12.83,0,0,1-8.2-2.9c-3.4-2.9-5.8-8.3-3.6-12.6a7.76,7.76,0,0,1,5-4c3.1-.6,6.5,1.1,8.8,4.3l.2-.7a7.63,7.63,0,0,1,9-5.8,28.56,28.56,0,0,0,5.8.6h.2a29.07,29.07,0,0,0,14.9-4.1l1.5,2.6a32.61,32.61,0,0,1-16.4,4.5h-.2a27.3,27.3,0,0,1-6.4-.7,4.66,4.66,0,0,0-5.5,3.5l-1.1,4.7a1.49,1.49,0,0,1-1.8,1.1h0a1.57,1.57,0,0,1-1.1-1c-1.5-4.5-4.9-6.7-7.3-6.2a5,5,0,0,0-2.9,2.4c-1.5,2.9.3,6.8,2.9,9a10.2,10.2,0,0,0,6.2,2.2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    d: "M36.2,192a25.4,25.4,0,0,1-.4-18.4,21.81,21.81,0,0,1,6.6-9.3c4.2-3.3,9.5-4.9,15.8-4.6a23.58,23.58,0,0,1,9.4,2.6,22.35,22.35,0,0,0,8.3,2.6A26.24,26.24,0,0,0,87,163.7l1.3-.4.5,1.3a15.85,15.85,0,0,1,0,12.1c-3.3,7.8-11.4,9.4-12.3,9.5l-.5-3c.3-.1,7.3-1.3,10-7.7a12.68,12.68,0,0,0,.4-8.6,28.51,28.51,0,0,1-10.9.9,25.25,25.25,0,0,1-9.3-2.9,18,18,0,0,0-8.2-2.3c-5.6-.2-10.2,1.1-13.8,4a19,19,0,0,0-5.7,8,22.63,22.63,0,0,0,.3,16.2Zm4.1,39.4-2.6-1.5c4.9-8.7,4.2-17.2,3.7-23.4a39.27,39.27,0,0,1-.3-4.6h3a38.9,38.9,0,0,0,.3,4.4c.5,6.5,1.3,15.5-4.1,25.1Zm27.3,8.8c-2.7-3.7-2.4-11.6-2.3-15.5v-1.3h3v1.4c-.1,2.9-.4,10.8,1.7,13.6Zm193.7-14.6a20.29,20.29,0,0,1-6-.9,7.53,7.53,0,0,1-5-5.5c-.2-.7-.3-1.4-.5-2a53.48,53.48,0,0,1-1.7-10.5,71.31,71.31,0,0,1,1.8-21.6l2.9.6a72.67,72.67,0,0,0-1.8,20.8,48.49,48.49,0,0,0,1.6,10l.5,2a4.38,4.38,0,0,0,3,3.3,16.77,16.77,0,0,0,6.3.7,18.6,18.6,0,0,0,12.3-6.6l2.3,1.9a21.2,21.2,0,0,1-14.4,7.8,2.82,2.82,0,0,0-1.3,0Zm32.1,5.8c-5.4-9.5-4.6-18.5-4-25.1.1-1.7.3-3.1.3-4.4h3a39.27,39.27,0,0,1-.3,4.6c-.5,6.2-1.2,14.7,3.7,23.4Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M266,241.4l-2.4-1.8c2.1-2.9,1.9-12,1.8-15v-1.2h3v1.1C268.6,231.1,268.4,238.2,266,241.4ZM146.7,197.3l-2.1-2.1a60.4,60.4,0,0,0,8.4-11,106.78,106.78,0,0,0,6.1-12.2,1.51,1.51,0,0,1,2-.8h0a1.47,1.47,0,0,1,.6.5c.1.1,7.2,9.3,14,14a56.42,56.42,0,0,0,14.8,7.2l-.9,2.9a56.45,56.45,0,0,1-15.6-7.6c-5.3-3.6-10.6-9.6-13.1-12.7a84.79,84.79,0,0,1-5.3,10.4,64.84,64.84,0,0,1-8.9,11.4Zm6.5,45.8-1.1-2.8a9.42,9.42,0,0,0,5.8-8.1v-3.7h3v3.7A12.15,12.15,0,0,1,153.2,243.1Zm32.5.1c-5.3-2-7.2-7-7.2-11v-3.7h3v3.7a8.46,8.46,0,0,0,5.3,8.2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    d: "M147,210.7l-1.5-.7a7.13,7.13,0,0,1-4.2-4.6l-1-3.7a5.24,5.24,0,0,1,2.6-5.9c1.7-.8,4-.7,5.1,1.3l-2.6,1.5c-.2-.4-1.2,0-1.2,0a1.93,1.93,0,0,0-1,2.4l1,3.7a3.69,3.69,0,0,0,2.4,2.6h.1l1.5.7Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_19",
    "data-name": "Pfad 19",
    d: "M169.6,234.1a13.7,13.7,0,0,1-9.3-3.6l-5.1-4.7a33.79,33.79,0,0,1-8.9-21.1V194.6h3v10a30.57,30.57,0,0,0,8.1,19l5,4.6a10.8,10.8,0,0,0,14.7-.1l4.8-4.6a30.69,30.69,0,0,0,7.7-18.7l-.2-5.4,3-.1.3,5.5v.2a33.37,33.37,0,0,1-8.5,20.6l-.1.1-4.8,4.6A14.48,14.48,0,0,1,169.6,234.1ZM124.7,305h-3V277.4a40.44,40.44,0,0,1,1.6-11.5A38.15,38.15,0,0,1,153,239.4l2.1-.4-.3,2.1a6.08,6.08,0,0,0-.1,1.9c0,10.3,12.1,18.3,15.2,18.3,1.5,0,5.7-2.2,9.4-6.2,2.4-2.6,6.2-7.8,5.7-14.2l3-.2c.4,5.6-1.9,11.4-6.5,16.4-3.8,4.1-8.7,7.1-11.6,7.1-5,0-18.2-9.7-18.2-21.3v-.2a35.38,35.38,0,0,0-25.4,24,38.23,38.23,0,0,0-1.5,10.6Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_20",
    "data-name": "Pfad 20",
    d: "M216.3,300.8h-3V277.4a37.71,37.71,0,0,0-1.5-10.6,35.23,35.23,0,0,0-27.3-24.5l.5-2.9a38,38,0,0,1,29.6,26.5,37.18,37.18,0,0,1,1.6,11.5Zm67-95.1v-3a9.34,9.34,0,0,0,6-2.1c2.4-2.1,4.2-6,2.8-8.7a5.09,5.09,0,0,0-2.8-2.4c-2.3-.5-5.6,1.7-7,6a1.5,1.5,0,0,1-2.9-.1l-1-4.6c-.1-.6-.2-1.4-.3-2.2-.6-4.7-1.4-8.2-5.8-8.1-1.6,0-3.4,1.3-5.2,2.6-2,1.4-4.4,3.1-7.1,3.5-7.7,1.2-11.7-.3-11.9-.4a1.54,1.54,0,0,1-1-1.5c0-.3,1.6-26.2,27.3-26.2.4,0,10,.1,16.7,5.4,9.4,7.4,13,19.3,9.5,31l-2.9-.9c3.2-10.7,0-21.1-8.5-27.8-5.9-4.7-14.5-4.7-14.9-4.7-20.1,0-23.6,17.3-24.2,22.1a25.83,25.83,0,0,0,9.2-.1c2-.3,4-1.7,5.8-3,2.1-1.5,4.4-3.1,6.9-3.2h.3c7.2,0,8.1,7,8.6,10.8.1.8.2,1.4.3,1.9l.1.6c2.2-3.1,5.5-4.8,8.5-4.1a7.68,7.68,0,0,1,4.9,3.9c2.2,4.2-.2,9.5-3.5,12.4a12,12,0,0,1-7.9,2.9Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_6",
    "data-name": "Rechteck 6",
    x: 253.6,
    y: 116.4,
    width: 26.3,
    height: 3,
    fill: "#d1e545"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_21",
    "data-name": "Pfad 21",
    d: "M265.1,83.3h-7.5a7.5,7.5,0,1,1,7.5-7.5h0Zm-7.5-12a4.52,4.52,0,0,0-.8,9h5.3V75.8a4.48,4.48,0,0,0-4.5-4.5Zm19.3,12h-7.5V75.8a7.5,7.5,0,1,1,7.5,7.5Zm-4.5-3h4.5a4.5,4.5,0,1,0-4.5-4.5Z",
    fill: "#d1e545"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_7",
    "data-name": "Rechteck 7",
    x: 269.4,
    y: 81.8,
    width: 3,
    height: 26,
    fill: "#d1e545"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_8",
    "data-name": "Rechteck 8",
    x: 262,
    y: 80.8,
    width: 3,
    height: 27.9,
    fill: "#d1e545"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_22",
    "data-name": "Pfad 22",
    d: "M266.7,136.4a8.24,8.24,0,0,1-8.2-8.2h3a5.21,5.21,0,1,0,10.4.6v-.5h3A8.22,8.22,0,0,1,266.7,136.4Z",
    fill: "#d1e545"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_23",
    "data-name": "Pfad 23",
    d: "M273.4,129.1H260.8a8.75,8.75,0,0,1-8.8-8.8V106.6h3v13.7a5.8,5.8,0,0,0,5.8,5.8h12.6a5.8,5.8,0,0,0,5.8-5.8h0V107h3v13.3A8.94,8.94,0,0,1,273.4,129.1Z",
    fill: "#d1e545"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_24",
    "data-name": "Pfad 24",
    d: "M266.9,111a34.2,34.2,0,1,1,34.2-34.2h0A34.18,34.18,0,0,1,266.9,111Zm0-65.4a31.2,31.2,0,1,0,31.2,31.2h0a31,31,0,0,0-31.2-31.2Z",
    fill: "#d1e545"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lamp"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.08,
    y: 24.32,
    width: 9.9,
    height: 3,
    transform: "translate(160.73 282.99) rotate(-69.58)",
    fill: "#d1e545"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Lamp",
    x: 245.09,
    y: 23.19,
    width: 3,
    height: 9.9,
    transform: "translate(10.47 104.59) rotate(-24.45)",
    fill: "#d1e545"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Lamp",
    x: 218.67,
    y: 50.75,
    width: 3,
    height: 9.8,
    transform: "translate(90.79 242.28) rotate(-69.45)",
    fill: "#d1e545"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Lamp",
    x: 306.2,
    y: 51.09,
    width: 9.9,
    height: 3,
    transform: "translate(6.15 133.56) rotate(-24.46)",
    fill: "#d1e545"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_25",
    "data-name": "Pfad 25",
    d: "M45.3,136.3V120h-11a8.71,8.71,0,0,1-8.7-8.7v-63a8.71,8.71,0,0,1,8.7-8.7h93.4a8.71,8.71,0,0,1,8.7,8.7v63.1a8.71,8.71,0,0,1-8.7,8.7H63.2Zm-11-93.8a5.76,5.76,0,0,0-5.7,5.7v63a5.76,5.76,0,0,0,5.7,5.7H48.2v12.6L62.1,117h65.6a5.76,5.76,0,0,0,5.7-5.7v-63a5.76,5.76,0,0,0-5.7-5.7Z",
    fill: "#d1e545"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_26",
    "data-name": "Pfad 26",
    d: "M138.4,152.1l-18-17.7H62.9v-3h58.7L135.4,145V131.4h13.9a5.76,5.76,0,0,0,5.7-5.7V65a5.76,5.76,0,0,0-5.7-5.7h-7.2v-3h7.2A8.71,8.71,0,0,1,158,65v60.7a8.71,8.71,0,0,1-8.7,8.7H138.4v17.7Z",
    fill: "#d1e545"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 61.6,
    width: 72.9,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Text",
    x: 43,
    y: 78.6,
    width: 36.5,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Text",
    x: 92.1,
    y: 78.6,
    width: 23.3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Text",
    x: 43,
    y: 95.5,
    width: 58.5,
    height: 3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Dots"
  }, /*#__PURE__*/React.createElement("path", {
    id: "r30",
    d: "M314.3,247.6l2,2.2c1-.9,2-1.9,2.9-2.8l-2.1-2.1C316.2,245.8,315.3,246.7,314.3,247.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r29",
    d: "M322.1,244.1l2.7-3-2.3-2c-.9,1-1.7,2-2.6,2.9l2.2,2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r28",
    d: "M325.1,236.1l2.4,1.9h0c.8-1.1,1.7-2.1,2.5-3.2l-2.4-1.7A36.12,36.12,0,0,0,325.1,236.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r27",
    d: "M332.2,231.4h0c.8-1.1,1.5-2.3,2.2-3.4l-2.6-1.6-2.1,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r26",
    d: "M336.4,224.5h0c.7-1.2,1.3-2.4,1.9-3.6l-2.7-1.4c-.6,1.2-1.2,2.3-1.9,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r25",
    d: "M340.1,217.2h0c.6-1.2,1.1-2.5,1.6-3.7l-2.8-1.1c-.5,1.2-1,2.4-1.6,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r24",
    d: "M343.2,209.7c.5-1.3.9-2.6,1.3-3.9l-2.9-.9c-.4,1.2-.8,2.5-1.3,3.7l2.9,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r23",
    d: "M345.6,202h0c.4-1.3.7-2.6,1-3.9l-2.9-.7c-.3,1.3-.6,2.6-1,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r22",
    d: "M347.5,194.1c.2-1.3.5-2.7.7-4l-3-.4-.6,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r21",
    d: "M348.6,186h0c.1-1.4.3-2.7.3-4l-3-.2-.3,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r20",
    d: "M349.2,177.9v-4h-3v4h3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r19",
    d: "M349.1,169.8c-.1-1.4-.2-2.7-.3-4.1l-3,.3.3,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r18",
    d: "M348.3,160.7c-.2-1.3-.4-2.7-.6-4l-3,.5.6,3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r17",
    d: "M346.9,153.7l-.9-3.9-2.9.8c.3,1.3.6,2.6.9,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r16",
    d: "M344.9,145.9l-1.2-3.9-2.8,1c.4,1.2.8,2.5,1.2,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r15",
    d: "M342.2,138.2c-.5-1.2-1-2.5-1.6-3.7l-2.7,1.2,1.5,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r14",
    d: "M338.9,130.8c-.6-1.2-1.2-2.4-1.9-3.6l-2.6,1.4c.6,1.1,1.2,2.3,1.8,3.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r13",
    d: "M335.1,123.7c-.7-1.2-1.4-2.3-2.1-3.4l-2.5,1.6,2.1,3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r12",
    d: "M330.6,116.9l-2.4-3.3-2.4,1.8a37.12,37.12,0,0,1,2.3,3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r11",
    d: "M325.7,110.4c-.9-1-1.8-2.1-2.7-3.1l-2.2,2c.9,1,1.8,2,2.6,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r10",
    d: "M320.2,104.4c-1-1-1.9-1.9-2.9-2.8l-2.1,2.2c.9.9,1.9,1.8,2.8,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r9",
    d: "M309.3,98.6c1,.8,2,1.7,3,2.5l2-2.3c-1-.9-2.1-1.8-3.1-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r8",
    d: "M303,94a37.12,37.12,0,0,1,3.2,2.3l1.8-2.5c-1.1-.8-2.2-1.6-3.3-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r7",
    d: "M219,75.3l.6,2.9h0c1.3-.3,2.6-.5,3.9-.8l-.5-3C221.7,74.8,220.4,75,219,75.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r6",
    d: "M211.2,77.4l.9,2.9h0c1.2-.4,2.5-.8,3.8-1.1l-.8-2.9C213.8,76.6,212.5,77,211.2,77.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r5",
    d: "M203.6,80.3l1.2,2.7h0c1.2-.5,2.4-1,3.6-1.4l-1-2.8C206.1,79.2,204.8,79.8,203.6,80.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r4",
    d: "M196.2,83.8l1.4,2.6h0c1.1-.6,2.3-1.2,3.5-1.8l-1.3-2.7C198.6,82.5,197.4,83.2,196.2,83.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r3",
    d: "M189.2,88l1.6,2.5h0l3.3-2.1-1.5-2.6C191.5,86.5,190.4,87.2,189.2,88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r2",
    d: "M182.7,92.7l1.9,2.3h0c1-.8,2.1-1.6,3.1-2.4l-1.8-2.4C184.8,91.1,183.7,91.9,182.7,92.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r1",
    d: "M176.6,98.1l2.1,2.2c.9-.9,1.9-1.8,2.9-2.7l-2-2.2A26.12,26.12,0,0,0,176.6,98.1Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartMeetingIllustration);
export default __webpack_public_path__ + "static/media/start-meeting-illustration.6bb0ed633ca94b8cf19c846deb0048bd.svg";
export { ForwardRef as ReactComponent };